import { IconButton, IconButtonColorEnum, IconButtonSizeEnum, TIcon } from '@acceso/design-system';

type ActionProps = {
  icon: TIcon;
  onClick: VoidFunction;
};

export function Action({ icon: Icon, onClick }: ActionProps) {
  return (
    <IconButton
      size={IconButtonSizeEnum.SM}
      color={IconButtonColorEnum.NONE_DEFAULT}
      onClick={onClick}
    >
      <Icon />
    </IconButton>
  );
}
